import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const Paste = ({ children }) => {
    return _jsx(_Fragment, { children: children });
};
export default Paste;
